<template>
  <div
    class="row bg-origami"
    data-test="plans-for-every-budget">
    <HomepageSection
      :title="title"
      :paragraph="paragraphText"/>
    <PlansSection/>
    <PlanIncludes/>
  </div>
</template>

<script setup>
import PlansSection from '@/homepage/components/sections/PlansForEveryBudget/PlansSection.vue'
import PlanIncludes from '@/homepage/components/sections/PlansForEveryBudget/PlanIncludes.vue'
import HomepageSection from '@/homepage/components/HomepageSection.vue'

defineProps({
  title: {
    type: String,
    default: 'Plans For Every Budget'
  }
})

const paragraphText = 'All plans allow you to keep your at-home items until your new case arrives, so you\'re never without a great wardrobe!'
</script>
